import ThemeUtils from '../utils/ThemeUtils';
import CartRequests from '../utils/CartRequests';

export default class LineItem {
  constructor(el) {
    this.el = el;

    this.key = el.dataset.lineItem;

    this.removeButtonEl = el.querySelector('[data-line-item-remove]');

    this.quantityInputEl = el.querySelector('[data-line-item-quantity-input]');
    this.quantityDecrementEl = el.querySelector('[data-line-item-quantity-decrement]');
    this.quantityIncrementEl = el.querySelector('[data-line-item-quantity-increment]');

    this.remove = (e) => {
      e.preventDefault();
      this._changeQuantity(0);
    };
    this.decrementQuantity = (e) => {
      e.preventDefault();
      this._changeQuantity(parseInt(this.quantityInputEl.value, 10) - 1);
    };
    this.incrementQuantity = (e) => {
      e.preventDefault();
      this._changeQuantity(parseInt(this.quantityInputEl.value, 10) + 1);
    };
    this.onQuantityChange = this._onQuantityChange.bind(this);

    this.removeButtonEl.addEventListener('click', this.remove);
    this.quantityDecrementEl.addEventListener('click', this.decrementQuantity);
    this.quantityIncrementEl.addEventListener('click', this.incrementQuantity);
    this.quantityInputEl.addEventListener('change', this.onQuantityChange);
  }

  _onQuantityChange() {
    const quantity = Math.max(0, this.quantityInputEl.value);

    CartRequests.changeItem({
      id: this.key,
      quantity,
    });
  }

  _changeQuantity(quantity) {
    const event = document.createEvent('Event');

    event.initEvent('change', false, true);

    this.quantityInputEl.value = quantity;
    this.quantityInputEl.dispatchEvent(event);
  }

  unload() {
    this.removeButtonEl.removeEventListener('click', this.remove);
    this.quantityDecrementEl.removeEventListener('click', this.decrementQuantity);
    this.quantityIncrementEl.removeEventListener('click', this.incrementQuantity);
    this.quantityInputEl.removeEventListener('change', this.onQuantityChange);
  }
}
